import React from 'react';
import { ArrowUpRightFromSquare as LinkIcon } from '@gravity-ui/icons';
import { ActionTooltip, Button, Icon } from '@gravity-ui/uikit';
import { cn } from '../classname';
import { i18n } from '../i18n/forms';
import './UrlInputRow.css';
const b = cn('url-input-row');
export const UrlInputRow = React.memo(function UrlInputRow({ href, input }) {
    return (React.createElement("div", { className: b() },
        input,
        React.createElement(ActionTooltip, { title: i18n('link_open_help') },
            React.createElement(Button, { className: b('button'), view: "flat", size: "s", href: href, target: "_blank" },
                React.createElement(Icon, { data: LinkIcon, size: 16 })))));
});
